import React, { useState, useEffect, useCallback } from 'react';
import axiosClient from '../../../axios-client';
import { AiFillDelete } from 'react-icons/ai';
import { HamburgerIcon, SearchIcon } from '@chakra-ui/icons'
import MyPagination from "../../../components/MyPagination";
import { BiDetail } from 'react-icons/bi';
import { MdOutlineQuestionAnswer } from 'react-icons/md';
import moment from 'moment';


import {
  Flex,
  Box,
  Heading,
  Button,
  Stack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  InputGroup,
  HStack,
  Td,
  TableContainer,
  useColorModeValue,
  InputLeftElement,
  Badge,
  useToast,
  Input,

  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Select,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Text,
  FormControl,
  FormLabel,
  Textarea,
  Popover,
  PopoverTrigger,
  IconButton,
  PopoverContent,
  PopoverHeader,
  PopoverArrow,
  PopoverCloseButton,
  PopoverBody,
  Image,
  Alert,
  AlertIcon,
  Skeleton,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
} from '@chakra-ui/react';

import { Switch } from '@chakra-ui/react';
import { useStateContext } from "../../../context/ContextProvider";
import { MdHistory } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


export const GestTickets = () => {
  const { user, setUser, setToken } = useStateContext();
  const navigate = useNavigate()
  const { t } = useTranslation();

  const { updateTicketCount } = useStateContext();
  const [countManager, setCountManager] = useState([]);
  const [countCallCenter, setCountCallCenter] = useState([]);
  const [countStockManager, setCountStockManager] = useState([]);


  const [checkLengthDataM, setCheckLengthDataM] = useState(false)
  const [checkLengthDataC, setCheckLengthDataC] = useState(false)
  const [checkLengthDataS, setCheckLengthDataS] = useState(false)

  const [loadingData, setLoadingData] = useState(true)
  const [paginationDataManager, setPaginationDataManager] = useState()
  const [paginationDataCallCenter, setPaginationDataCallCenter] = useState()
  const [paginationDataStockManager, setPaginationDataStockManager] = useState()

  const [dataManagers, setDataManagers] = useState([]);
  const [dataCallCenter, setDataCallCenter] = useState([]);
  const [dataStockManagers, setDataStockManagers] = useState([]);

  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isImgOpen, setIsImgOpen] = useState(false);


  const [reponseUser, setReponseUser] = useState('')

  const [resUserByWho, setResUserByWho] = useState('')
  const [userTime, setUserTime] = useState('')
  const [resByWho, setResByWho] = useState('')
  const [time, setTime] = useState('')

  const onOpenAlert = () => {
    setIsAlertOpen(true);
  };
  const onOpenImg = () => {
    setIsImgOpen(true);
  };

  const onOpenModal = () => {
    setIsModalOpen(true);
  };

  const onCloseAlert = () => {
    setIsAlertOpen(false);
    setDeleteId(null)
  };

  const onCloseImg = () => {
    setIsImgOpen(false);
  };

  const onCloseModal = () => {
    setIsModalOpen(false);
  };
  function formatDateToCustomFormat(dateString) {
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  ////////////////////////////////the size of the table//////////////////////////////
  const PAGE_SIZE = 10;
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setCurrentPage(0);
  };
  //////////////////////////////////////////////////////////////////////////////////
  const [deleteId, setDeleteId] = useState(null);
  const [reponse, setReponse] = useState('');
  const [sujet, setSujet] = useState('');
  const [content, setContent] = useState('');
  const [date, setDate] = useState("")

  const { isOpen, onOpen, onClose } = useDisclosure()

  //toast variable
  const toast = useToast()

  //search variable
  const [searchTerm, setSearchTerm] = useState('');

  //plainte data
  const [data, setData] = useState([]);
  //selected plainte
  const [dataDetail, setDataDetail] = useState('');

  const [currentPage, setCurrentPage] = useState(0);

  const [selectedEtat, setSelectedEtat] = useState(null);

  const [selectedCategory, setSelectedCategory] = useState('');




  //get the plainte data
  useEffect(() => {
    // setLoadingData(true)

    axiosClient.get(`/tickets/getAllTicketsClientManagers/?page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}&etat=${selectedEtat}&cat=${selectedCategory}&user=${user.id}&date=${date}`)
      .then((response) => {
        let filteredData = response.data.results;
        setPaginationDataManager(response.data);

        if (filteredData.length === 0) {
          setCheckLengthDataM(true)
        }
        else {
          setDataManagers(filteredData);
        }
        setLoadingData(false)

        if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
          setUser({});
          setToken(null);
          localStorage.removeItem("tokenExpirationTime");
          localStorage.removeItem("refreshTimeAdmin");
          localStorage.removeItem("role");

          // Vérifier si le toast n'est pas déjà affiché
          if (!toast.isActive('accountDisabled')) {
            toast({
              id: 'accountDisabled',
              description: t("le compte est désactivé"),
              status: 'warning',
              variant: 'left-accent',
              duration: 2000,
              isClosable: true,
              position: 'bottom-right'
            });
          }
        }

      })
      .catch((error) => {
        // // console.error(error);
        setLoadingData(false)
      });

    axiosClient.get(`/tickets/getAllTicketsClientCallCenter/?page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}&etat=${selectedEtat}&cat=${selectedCategory}&user=${user.id}&date=${date}`)
      .then((response) => {
        let filteredData = response.data.results;
        setPaginationDataCallCenter(response.data);

        if (filteredData.length === 0) {
          setCheckLengthDataC(true)
        }
        else {
          setDataCallCenter(filteredData);
        }

        setLoadingData(false)

        if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
          setUser({});
          setToken(null);
          localStorage.removeItem("tokenExpirationTime");
          localStorage.removeItem("refreshTimeAdmin");
          localStorage.removeItem("role");

          // Vérifier si le toast n'est pas déjà affiché
          if (!toast.isActive('accountDisabled')) {
            toast({
              id: 'accountDisabled',
              description: t("le compte est désactivé"),
              status: 'warning',
              variant: 'left-accent',
              duration: 2000,
              isClosable: true,
              position: 'bottom-right'
            });
          }
        }
      })
      .catch((error) => {
        // // console.error(error);
        setLoadingData(false)
      });

    axiosClient.get(`/tickets/getAllTicketsClientStockManager/?page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}&etat=${selectedEtat}&cat=${selectedCategory}&user=${user.id}&date=${date}`)
      .then((response) => {
        let filteredData = response.data.results;
        setPaginationDataStockManager(response.data);

        if (filteredData.length === 0) {
          setCheckLengthDataS(true)
        }
        else {
          setDataStockManagers(filteredData);
        }

        setLoadingData(false)

        if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
          setUser({});
          setToken(null);
          localStorage.removeItem("tokenExpirationTime");
          localStorage.removeItem("refreshTimeAdmin");
          localStorage.removeItem("role");

          // Vérifier si le toast n'est pas déjà affiché
          if (!toast.isActive('accountDisabled')) {
            toast({
              id: 'accountDisabled',
              description: t("le compte est désactivé"),
              status: 'warning',
              variant: 'left-accent',
              duration: 2000,
              isClosable: true,
              position: 'bottom-right'
            });
          }
        }
      })
      .catch((error) => {
        // // console.error(error);
        setLoadingData(false)
      });

    axiosClient.get(`/tickets/getManagerTicketsCount/?user=${user.id}`)
      .then((res) => {
        // console.log("okkk", res);
        setCountManager(res.data);

        if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
          setUser({});
          setToken(null);
          localStorage.removeItem("tokenExpirationTime");
          localStorage.removeItem("refreshTimeAdmin");
          localStorage.removeItem("role");

          // Vérifier si le toast n'est pas déjà affiché
          if (!toast.isActive('accountDisabled')) {
            toast({
              id: 'accountDisabled',
              description: t("le compte est désactivé"),
              status: 'warning',
              variant: 'left-accent',
              duration: 2000,
              isClosable: true,
              position: 'bottom-right'
            });
          }
        }
      })
      .catch((error) => {
        // // console.error(error);
      });

    axiosClient.get(`/tickets/getCallCenterTicketsCount/?user=${user.id}`)
      .then((res) => {
        // console.log("okkk", res);
        setCountCallCenter(res.data);

        if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
          setUser({});
          setToken(null);
          localStorage.removeItem("tokenExpirationTime");
          localStorage.removeItem("refreshTimeAdmin");
          localStorage.removeItem("role");

          // Vérifier si le toast n'est pas déjà affiché
          if (!toast.isActive('accountDisabled')) {
            toast({
              id: 'accountDisabled',
              description: t("le compte est désactivé"),
              status: 'warning',
              variant: 'left-accent',
              duration: 2000,
              isClosable: true,
              position: 'bottom-right'
            });
          }
        }
      })
      .catch((error) => {
        // // console.error(error);
      });

    axiosClient.get(`/tickets/getStockManagerTicketsCount/?user=${user.id}`)
      .then((res) => {
        // console.log("okkk", res);
        setCountStockManager(res.data);

        if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
          setUser({});
          setToken(null);
          localStorage.removeItem("tokenExpirationTime");
          localStorage.removeItem("refreshTimeAdmin");
          localStorage.removeItem("role");

          // Vérifier si le toast n'est pas déjà affiché
          if (!toast.isActive('accountDisabled')) {
            toast({
              id: 'accountDisabled',
              description: t("le compte est désactivé"),
              status: 'warning',
              variant: 'left-accent',
              duration: 2000,
              isClosable: true,
              position: 'bottom-right'
            });
          }
        }
      })
      .catch((error) => {
        // // console.error(error);
      });




  }, [selectedEtat, selectedCategory, pageSize, currentPage, searchTerm, user, date]);


  function update() {
    // setLoadingData(true)

    axiosClient.get(`/tickets/getAllTicketsClientManagers/?page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}&etat=${selectedEtat}&cat=${selectedCategory}&user=${user.id}&date=${date}`)
      .then((response) => {
        let filteredData = response.data.results;
        setPaginationDataManager(response.data);

        if (filteredData.length === 0) {
          setCheckLengthDataM(true)
        }
        else {
          setDataManagers(filteredData);
        }
        setLoadingData(false)

        if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
          setUser({});
          setToken(null);
          localStorage.removeItem("tokenExpirationTime");
          localStorage.removeItem("refreshTimeAdmin");
          localStorage.removeItem("role");

          // Vérifier si le toast n'est pas déjà affiché
          if (!toast.isActive('accountDisabled')) {
            toast({
              id: 'accountDisabled',
              description: t("le compte est désactivé"),
              status: 'warning',
              variant: 'left-accent',
              duration: 2000,
              isClosable: true,
              position: 'bottom-right'
            });
          }
        }

      })
      .catch((error) => {
        // // console.error(error);
        setLoadingData(false)
      });

    axiosClient.get(`/tickets/getAllTicketsClientCallCenter/?page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}&etat=${selectedEtat}&cat=${selectedCategory}&user=${user.id}&date=${date}`)
      .then((response) => {
        let filteredData = response.data.results;
        setPaginationDataCallCenter(response.data);

        if (filteredData.length === 0) {
          setCheckLengthDataC(true)
        }
        else {
          setDataCallCenter(filteredData);
        }

        setLoadingData(false)

        if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
          setUser({});
          setToken(null);
          localStorage.removeItem("tokenExpirationTime");
          localStorage.removeItem("refreshTimeAdmin");
          localStorage.removeItem("role");

          // Vérifier si le toast n'est pas déjà affiché
          if (!toast.isActive('accountDisabled')) {
            toast({
              id: 'accountDisabled',
              description: t("le compte est désactivé"),
              status: 'warning',
              variant: 'left-accent',
              duration: 2000,
              isClosable: true,
              position: 'bottom-right'
            });
          }
        }
      })
      .catch((error) => {
        // // console.error(error);
        setLoadingData(false)
      });

    axiosClient.get(`/tickets/getAllTicketsClientStockManager/?page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}&etat=${selectedEtat}&cat=${selectedCategory}&user=${user.id}&date=${date}`)
      .then((response) => {
        let filteredData = response.data.results;
        setPaginationDataStockManager(response.data);

        if (filteredData.length === 0) {
          setCheckLengthDataS(true)
        }
        else {
          setDataStockManagers(filteredData);
        }

        setLoadingData(false)

        if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
          setUser({});
          setToken(null);
          localStorage.removeItem("tokenExpirationTime");
          localStorage.removeItem("refreshTimeAdmin");
          localStorage.removeItem("role");

          // Vérifier si le toast n'est pas déjà affiché
          if (!toast.isActive('accountDisabled')) {
            toast({
              id: 'accountDisabled',
              description: t("le compte est désactivé"),
              status: 'warning',
              variant: 'left-accent',
              duration: 2000,
              isClosable: true,
              position: 'bottom-right'
            });
          }
        }
      })
      .catch((error) => {
        // // console.error(error);
        setLoadingData(false)
      });

    axiosClient.get(`/tickets/getManagerTicketsCount/?user=${user.id}`)
      .then((res) => {
        // console.log("okkk", res);
        setCountManager(res.data);

        if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
          setUser({});
          setToken(null);
          localStorage.removeItem("tokenExpirationTime");
          localStorage.removeItem("refreshTimeAdmin");
          localStorage.removeItem("role");

          // Vérifier si le toast n'est pas déjà affiché
          if (!toast.isActive('accountDisabled')) {
            toast({
              id: 'accountDisabled',
              description: t("le compte est désactivé"),
              status: 'warning',
              variant: 'left-accent',
              duration: 2000,
              isClosable: true,
              position: 'bottom-right'
            });
          }
        }
      })
      .catch((error) => {
        // // console.error(error);
      });

    axiosClient.get(`/tickets/getCallCenterTicketsCount/?user=${user.id}`)
      .then((res) => {
        // console.log("okkk", res);
        setCountCallCenter(res.data);

        if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
          setUser({});
          setToken(null);
          localStorage.removeItem("tokenExpirationTime");
          localStorage.removeItem("refreshTimeAdmin");
          localStorage.removeItem("role");

          // Vérifier si le toast n'est pas déjà affiché
          if (!toast.isActive('accountDisabled')) {
            toast({
              id: 'accountDisabled',
              description: t("le compte est désactivé"),
              status: 'warning',
              variant: 'left-accent',
              duration: 2000,
              isClosable: true,
              position: 'bottom-right'
            });
          }
        }
      })
      .catch((error) => {
        // // console.error(error);
      });

    axiosClient.get(`/tickets/getStockManagerTicketsCount/?user=${user.id}`)
      .then((res) => {
        // console.log("okkk", res);
        setCountStockManager(res.data);

        if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
          setUser({});
          setToken(null);
          localStorage.removeItem("tokenExpirationTime");
          localStorage.removeItem("refreshTimeAdmin");
          localStorage.removeItem("role");

          // Vérifier si le toast n'est pas déjà affiché
          if (!toast.isActive('accountDisabled')) {
            toast({
              id: 'accountDisabled',
              description: t("le compte est désactivé"),
              status: 'warning',
              variant: 'left-accent',
              duration: 2000,
              isClosable: true,
              position: 'bottom-right'
            });
          }
        }
      })
      .catch((error) => {
        // // console.error(error);
      });

  }




  //delete plainte
  // const handleDelete = (id = deleteId) => {
  //   if (!id) return;
  //   axiosClient.delete(`/tickets/${id}/`)
  //     .then((response) => {
  //       setData((prevData) => prevData.filter((row) => row.id !== id));
  //       toast({
  //         description: "le ticket est supprimé avec succès",
  //         status: 'warning',
  //         duration: 2000,
  //         isClosable: true,
  //         position: 'bottom-right'
  //       })
  //     })
  //     .catch((error) => {
  //       // console.error(error);
  //     });
  //   onCloseAlert()
  // }

  const [plainteData, setPlainteData] = useState({ content: "", sujet: "", etat: 0, user: "", response: "" });
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setPlainteData((prevUserData) => ({
      ...prevUserData,
      response: value,
    }));
  };

  const [message, setMessage] = useState('')

  //send response
  const sendResponse = (id = deleteId) => {
    if (!id) return;
    if (plainteData.response.trim() === "") {
      setMessage(t("Veuillez saisir une réponse"));
      return;
    }
    function formatDateTime(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
    const updatedPlainteData = {
      response: plainteData.response,
      edited_by: user.first_name + ' ' + user.last_name,
      responsebywho: user.first_name + ' ' + user.last_name,
      responsetime: formatDateTime(new Date())
    };
    axiosClient.patch(`/tickets/${deleteId}/`, updatedPlainteData)
      .then(() => {
        toast({
          description: t("votre réponse est envoyée avec succès"),
          status: 'success',
          duration: 2000,
          isClosable: true,
          variant: "left-accent",
        })
        update()
        setMessage("")
      }
      )
      .catch(() => {});
    onCloseAlert()
  }

  //get plainte
  useEffect(() => {
    axiosClient.get(`/tickets/${deleteId}/`)
      .then((response) => {
        setDataDetail(response.data.sort().reverse());
      })
      .catch((error) => {
        // // console.error(error);
      });
  }, [deleteId, dataDetail.response]);

  //edit the plainte state ('encours','Réglée')
  const handleEtatClick = (id, etat) => {
    const formData = new FormData();
    formData.append("etat", !etat);
    formData.append("edited_by", user.first_name + ' ' + user.last_name);

    axiosClient.patch(`/tickets/${id}/`, formData)
      .then((response) => {
        updateTicketCount()
        update()
        const updatedRow = response.data;
        // Update the row object with the new etat value
        setDataManagers(rows => rows.map(row => {
          if (row.id === id) {
            return {
              ...row,
              etat: !etat,
              date_modification: moment(updatedRow.date_modification).format('YYYY-MM-DD HH:mm:ss'),
              edited_by: updatedRow.edited_by || (user.first_name + ' ' + user.last_name),
            };
          }
          return row;
        }));
        setDataCallCenter(rows => rows.map(row => {
          if (row.id === id) {
            return {
              ...row,
              etat: !etat,
              date_modification: moment(updatedRow.date_modification).format('YYYY-MM-DD HH:mm:ss'),
              edited_by: updatedRow.edited_by || (user.first_name + ' ' + user.last_name),
            };
          }
          return row;
        }));
        setDataStockManagers(rows => rows.map(row => {
          if (row.id === id) {
            return {
              ...row,
              etat: !etat,
              date_modification: moment(updatedRow.date_modification).format('YYYY-MM-DD HH:mm:ss'),
              edited_by: updatedRow.edited_by || (user.first_name + ' ' + user.last_name),
            };
          }
          return row;
        }));

        setMessage("")
        // // console.error(response);
      })
      .catch(() => {});
    if (!etat) {
      toast({
        description: t("le ticket est réglé"),
        status: 'success',
        duration: 2000,
        isClosable: true,
        variant: "left-accent",
        position: 'bottom-right'
      })

    }
    else {
      toast({
        description: t("le ticket est encours"),
        status: 'warning',
        duration: 2000,
        isClosable: true,
        variant: "left-accent",
        position: 'bottom-right'
      })
    }
  }


  const viderInputs = () => {
    setSearchTerm('')
    setSelectedCategory('')
    setDate("")
    // setSelectedEtat('')
  }

  const bg = useColorModeValue("white", "gray.700");

  const formatDate = (dateString) => {
    if (dateString) {
      const [year, month, day] = dateString.split('-');
      return `${day}-${month}-${year}`;
    }

  };
  const color = useColorModeValue("black", "white");
  const txtcolor = useColorModeValue("white", "black");

  return (
    <Box mt="5px" >

      <Flex>
        <Box w="90%" mt={2} mb={5}>
          <Breadcrumb fontFamily='Plus Jakarta Display' fontStyle={"italic"} fontSize={{ base: "20px", sm: "25px", lg: "27px" }} color="gray">
            <BreadcrumbItem>
              <BreadcrumbLink onClick={() => navigate('/')}>{t("Accueil")}</BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbItem isCurrentPage>
              <BreadcrumbLink>{t("Propositions d'amélioration")}</BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>
        </Box>
      </Flex>
      <Stack>
        <Tabs isLazy>
          <TabList  >

            {user.role === "AdminClient" &&
              <Tab onClick={viderInputs}>
                <Text fontSize={{ base: 12, lg: 15 }}>Manager
                  {countManager > 0 && (
                    <Badge rounded="full" bg="#df2e38" style={{ padding: "2px 7px 2px 6px" }} color="white" ml='2'>
                      {countManager}
                    </Badge>
                  )}</Text>
              </Tab>}

            <Tab onClick={viderInputs}>
              <Text fontSize={{ base: 12, lg: 15 }}>{t("Centre d'appel")}
                {countCallCenter > 0 && (
                  <Badge rounded="full" bg="#df2e38" style={{ padding: "2px 7px 2px 6px" }} color="white" ml='2'>
                    {countCallCenter}
                  </Badge>
                )}</Text>
            </Tab>
            <Tab onClick={viderInputs}>
              <Text fontSize={{ base: 12, lg: 15 }}>{t("Gestionnaire de stock")}
                {countStockManager > 0 && (
                  <Badge rounded="full" bg="#df2e38" style={{ padding: "2px 7px 2px 6px" }} color="white" ml='2'>
                    {countStockManager}
                  </Badge>
                )}</Text>
            </Tab>
          </TabList>
          <TabPanels >


            {user.role === "AdminClient" &&
              <TabPanel>
                <Flex
                  align={'center'}
                  justify={'center'}

                >
                  <Stack

                    w={'full'}
                    maxW='full'
                    bg={bg}
                    rounded={'xl'}
                    p={6}
                    my={5}>
                    {/* Search input */}
                    <Flex
                      justifyContent="space-between"
                      alignItems="center"
                      direction={{ base: 'column', lg: 'row' }}
                      mb={{ base: 2, md: 4 }}
                    >
                      <Flex direction={{ base: 'column', lg: 'row' }} mb={3} w={{ base: '100%', lg: "70%" }} >
                        <Flex w={{ base: '100%', lg: "65%" }} mb={{ base: 3, lg: 0 }}>
                          <Select borderRadius="5" fontSize={{ base: 13, lg: 16 }} w={{ base: '70%', lg: '70%' }} mr={3} value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
                            <option value="">{t("Toutes les catégories")}</option>
                            <option value="technical_support">{t("Support technique")}</option>
                            <option value="account_assistance">{t("Assistance pour le compte")}</option>
                            <option value="feedback_suggestions">{t("Commentaires et suggestions")}</option>
                            <option value="content_issues">{t("Problèmes de contenu")}</option>
                            <option value="general_inquiries">{t("Demandes générales")}</option>
                            {/* <option value="problem_with_client">Problème avec client</option> */}
                          </Select>

                          <Select mr={{ base: 0, lg: 3 }} borderRadius="5" fontSize={{ base: 13, lg: 16 }} w={{ base: '30%', lg: '30%' }} value={selectedEtat} onChange={(e) => setSelectedEtat(e.target.value === '' ? null : e.target.value === 'true')}>
                            <option value="">{t("Tout")}</option>
                            <option value="true">{t("Réglé")}</option>
                            <option value="false">{t("En cours")}</option>
                          </Select>
                        </Flex>
                        <Input borderRadius={"5"} onChange={e => setDate(e.target.value)} w={{ base: '100%', lg: '20%' }} placeholder='Select Date' size='md' type='month' />

                      </Flex>

                      <InputGroup w={{ base: '100%', lg: "30%" }}>
                        <InputLeftElement
                          pointerEvents='none'
                          children={<SearchIcon color='gray.300' />}
                        />
                        <Input
                          borderRadius="5"
                          placeholder={t("Recherche...")}
                          value={searchTerm}
                          onChange={(e) => {
                            setCurrentPage(0)
                            setSearchTerm(e.target.value)
                          }}
                          mb={4}
                          sx={{
                            marginLeft: 'auto',
                          }}
                        />
                      </InputGroup>

                    </Flex>

                    {/* Plainte Table  */}

                    <TableContainer>
                      <Table variant='simple' >
                        <Thead>
                          <Tr>
                            <Th borderBottomColor='gray.400'>Code</Th>
                            <Th borderBottomColor='gray.400' >{t("Manager")}</Th>
                            <Th borderBottomColor='gray.400'>Date</Th>
                            <Th borderBottomColor='gray.400'>{t("État")}</Th>
                            <Th borderBottomColor='gray.400'>{t("Catégorie")}</Th>
                            <Th borderBottomColor='gray.400'>{t("Contenu")}</Th>
                            {/* <Th borderBottomColor='gray.400'>{t("Réponse")}</Th>
                          <Th borderBottomColor='gray.400'>{t("Historique")}</Th> */}
                            <Th borderBottomColor='gray.400'>Options</Th>

                          </Tr>
                        </Thead>
                        <Tbody>
                          {loadingData &&
                            <Tr>
                              <Td><Skeleton size='10' /></Td>
                              <Td> <Skeleton height='20px' /></Td>
                              <Td> <Skeleton height='20px' /></Td>
                              <Td> <Skeleton height='20px' /></Td>
                              <Td> <Skeleton height='20px' /></Td>
                              <Td> <Skeleton height='20px' /></Td>
                              <Td> <Skeleton height='20px' /></Td>

                            </Tr>}
                          {(!searchTerm && selectedEtat === null && !selectedCategory) && paginationDataManager?.length === 0 ? (
                            <Tr>
                              <Td colSpan={11}>{t("Il n'y a pas de tickets à afficher")}</Td>
                            </Tr>) :
                            <>
                              {(paginationDataManager?.length !== 0) &&
                                dataManagers?.map((row) => (
                                  <Tr key={row.id}>
                                    <Td>{row.code}</Td>
                                    <Td>{row.first_name} {row.last_name}</Td>

                                    <Td>{new Date(row.created_at).toLocaleDateString(t('fr-FR'))}</Td>
                                    <Td>
                                      <Flex>
                                        <Stack direction='row' mr="3px">
                                          <Switch
                                            colorScheme='green'
                                            isChecked={row.etat}
                                            onChange={() => handleEtatClick(row.id, row.etat)}
                                          />
                                        </Stack>
                                        <Badge
                                          rounded={'lg'}
                                          colorScheme={!row.etat ? 'yellow' : 'teal'}
                                        >
                                          {row.etat ? t('Réglé') : t('En cours')}
                                        </Badge>
                                      </Flex>
                                    </Td>
                                    <Td>{row.category === "technical_support" ? t("Support technique") :
                                      row.category === "account_assistance" ? t("Assistance pour le compte") :
                                        row.category === "feedback_suggestions" ? t("Commentaires et suggestions") :
                                          row.category === "content_issues" ? t("Problèmes de contenu") :
                                            row.category === "general_inquiries" ? t("Demandes générales") :
                                              row.category === "problem_with_partner" ? t("Problème avec partenaire") : ""}</Td>


                                    {/* <Td p={4}>

                                <Button
                                  size="sm"
                                  onClick={() => {
                                    setDeleteId(row.id);
                                    setSujet(row.sujet);
                                    setContent(row.content);
                                    onOpen();
                                  }}
                                  colorScheme='blue'
                                  leftIcon={<BiDetail />}>
                                  {t("Afficher")}
                                </Button></Td> */}

                                    {/* <Td p={4}>
                                    <Button
                                      size="sm"
                                      //onClick={onOpen}

                                      colorScheme='green'
                                      onClick={() => {
                                        setDeleteId(row.id);
                                        setReponse(row.response);
                                        setReponseUser(row.responseUser)
                                        onOpenAlert();
                                        setResUserByWho(row.responseUserbywho)
                                        setUserTime(row.responseUsertime)

                                        setResByWho(row.responsebywho)
                                        setTime(row.responsetime)
                                      }}
                                      leftIcon={<MdOutlineQuestionAnswer />}>
                                      {t("Repondre")}
                                    </Button></Td>

                                  <Td p={4}><Popover placement="left" >
                                    <PopoverTrigger>
                                      <Button
                                        size="sm"
                                        mr="5px"
                                        bg="gray.300"
                                        color={"black"}
                                        leftIcon={<MdHistory />}>
                                        {t("Historique")}
                                      </Button>

                                    </PopoverTrigger>
                                    <PopoverContent w={"full"} color="black" bgGradient='linear(to-r, white, gray)' >
                                      <PopoverHeader letterSpacing={1.5} pt={4} fontWeight="bold" border="0">
                                        {t("Historique")}
                                      </PopoverHeader>
                                      <PopoverArrow bg="gray" />
                                      <PopoverCloseButton />
                                      <PopoverBody>

                                        <div style={{ marginBottom: '8px' }}>
                                          {t("Modifié par")} : {row.edited_by}
                                        </div>

                                        <div>
                                          {t("Date de dernière modification")}: {new Date(row.date_modification).toLocaleString(t('fr-FR'))}
                                        </div>
                                      </PopoverBody>
                                      <PopoverHeader pt={4} fontWeight="bold" border="0">
                                      </PopoverHeader>
                                    </PopoverContent>
                                  </Popover></Td> */}
                                    <Td p={4}>

                                      <Button
                                        onClick={() => {
                                          setDeleteId(row.id);
                                          setSujet(row.sujet);
                                          setContent(row.content);
                                          onOpen();
                                        }}
                                        colorScheme='purple'
                                        variant={"outline"}
                                        leftIcon={<BiDetail />}>
                                        {t("Afficher")}
                                      </Button></Td>


                                    <Td>
                                      <Menu >
                                        <MenuButton
                                          as={IconButton}
                                          aria-label='Options'
                                          icon={<HamburgerIcon />}
                                          variant='outline'
                                        />
                                        <MenuList>
                                          <MenuItem onClick={() => {
                                            setDeleteId(row.id);
                                            setReponse(row.response);
                                            setReponseUser(row.responseUser)
                                            onOpenAlert();
                                            setResUserByWho(row.responseUserbywho)
                                            setUserTime(row.responseUsertime)

                                            setResByWho(row.responsebywho)
                                            setTime(row.responsetime)
                                          }} icon={<MdOutlineQuestionAnswer />} >
                                            {t("Repondre")}
                                          </MenuItem>
                                          <MenuItem icon={<MdHistory />} >
                                            {t("Historique")}
                                          </MenuItem>

                                        </MenuList>
                                      </Menu>
                                    </Td>
                                    {/* <Td>
                                    <Button
                                      size="sm"
                                      //onClick={onOpen}
                                      //onClick={() => handleDelete(row.id)}
                                      onClick={() => {
                                        setDeleteId(row.id);
                                        onOpenAlert();
                                      }}
                                      colorScheme='red'
                                      leftIcon={<AiFillDelete />}>
                                      Supprimer
                                    </Button></Td> */}
                                  </Tr>
                                ))}
                            </>}

                        </Tbody>
                        {((searchTerm || selectedEtat !== null || selectedCategory !== "") && paginationDataManager?.length === 0 || (checkLengthDataM)) && (
                          <Tr>
                            <Td colSpan={10}>{t("Aucune ligne correspondante n'a été trouvée.")}</Td>
                          </Tr>
                        )}
                      </Table>



                    </TableContainer>
                    {/* //////////////////////////////////////////Pagination////////////////////////////////////////// */}
                    <Flex flexDirection={{ base: 'column', lg: "row" }} justify="space-between" align="center" w="100%">
                      <Box flex="1">
                        <MyPagination
                          paginationData={paginationDataManager}
                          currentPage={currentPage}
                          setCurrentPage={setCurrentPage}
                          PAGE_SIZE={pageSize}
                        />
                      </Box>

                      <Select rounded={"md"} size={"sm"} w="70px" value={pageSize} onChange={handlePageSizeChange}>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </Select>
                    </Flex>
                    {/* //////////////////////////////////////////Pagination////////////////////////////////////////// */}

                  </Stack>
                </Flex>
              </TabPanel>
            }

            <TabPanel>
              <Flex
                align={'center'}
                justify={'center'}

              >
                <Stack

                  w={'full'}
                  maxW='full'
                  bg={bg}
                  rounded={'xl'}
                  p={6}
                  my={5}>
                  {/* Search input */}
                  <Flex
                    justifyContent="space-between"
                    alignItems="center"
                    direction={{ base: 'column', lg: 'row' }}
                    mb={{ base: 2, md: 4 }}
                  >
                    <Flex direction={{ base: 'column', lg: 'row' }} mb={3} w={{ base: '100%', lg: "70%" }} >
                      <Flex w={{ base: '100%', lg: "65%" }} mb={{ base: 3, lg: 0 }}>
                        <Select borderRadius="5" fontSize={{ base: 13, lg: 16 }} w={{ base: '70%', lg: '70%' }} mr={3} value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
                          <option value="">{t("Toutes les catégories")}</option>
                          <option value="technical_support">{t("Support technique")}</option>
                          <option value="account_assistance">{t("Assistance pour le compte")}</option>
                          <option value="feedback_suggestions">{t("Commentaires et suggestions")}</option>
                          <option value="content_issues">{t("Problèmes de contenu")}</option>
                          <option value="general_inquiries">{t("Demandes générales")}</option>
                          {/* <option value="problem_with_client">Problème avec client</option> */}
                        </Select>

                        <Select mr={{ base: 0, lg: 3 }} borderRadius="5" fontSize={{ base: 13, lg: 16 }} w={{ base: '30%', lg: '30%' }} value={selectedEtat} onChange={(e) => setSelectedEtat(e.target.value === '' ? null : e.target.value === 'true')}>
                          <option value="">{t("Tout")}</option>
                          <option value="true">{t("Réglé")}</option>
                          <option value="false">{t("En cours")}</option>
                        </Select>
                      </Flex>
                      <Input borderRadius={"5"} onChange={e => setDate(e.target.value)} w={{ base: '100%', lg: '20%' }} placeholder='Select Date' size='md' type='month' />

                    </Flex>

                    <InputGroup w={{ base: '100%', lg: "30%" }}>
                      <InputLeftElement
                        pointerEvents='none'
                        children={<SearchIcon color='gray.300' />}
                      />
                      <Input
                        borderRadius="5"
                        placeholder={t("Recherche...")}
                        value={searchTerm}
                        onChange={(e) => {
                          setCurrentPage(0)
                          setSearchTerm(e.target.value)
                        }}
                        mb={4}
                        sx={{
                          marginLeft: 'auto',
                        }}
                      />
                    </InputGroup>

                  </Flex>

                  {/* Plainte Table  */}

                  <TableContainer>
                    <Table variant='simple' >
                      <Thead>
                        <Tr>
                          <Th borderBottomColor='gray.400'>Code</Th>
                          <Th borderBottomColor='gray.400' >{t("Membre")}</Th>
                          <Th borderBottomColor='gray.400'>Date</Th>
                          <Th borderBottomColor='gray.400'>{t("État")}</Th>
                          <Th borderBottomColor='gray.400'>{t("Catégorie")}</Th>
                          <Th borderBottomColor='gray.400'>{t("Contenu")}</Th>
                          {/* <Th borderBottomColor='gray.400'>{t("Réponse")}</Th>
                          <Th borderBottomColor='gray.400'>{t("Historique")}</Th> */}
                          <Th borderBottomColor='gray.400'>Options</Th>

                        </Tr>
                      </Thead>
                      <Tbody>
                        {loadingData &&
                          <Tr>
                            <Td><Skeleton size='10' /></Td>
                            <Td> <Skeleton height='20px' /></Td>
                            <Td> <Skeleton height='20px' /></Td>
                            <Td> <Skeleton height='20px' /></Td>
                            <Td> <Skeleton height='20px' /></Td>
                            <Td> <Skeleton height='20px' /></Td>
                            <Td> <Skeleton height='20px' /></Td>

                          </Tr>}
                        {(!searchTerm && selectedEtat === null && !selectedCategory) && paginationDataCallCenter?.length === 0 ? (
                          <Tr>
                            <Td colSpan={11}>{t("Il n'y a pas de tickets à afficher")}</Td>
                          </Tr>) :
                          <>
                            {(paginationDataCallCenter?.length !== 0) &&
                              dataCallCenter?.map((row) => (
                                <Tr key={row.id}>
                                  <Td>{row.code}</Td>
                                  <Td>{row.first_name} {row.last_name}</Td>

                                  <Td>{new Date(row.created_at).toLocaleDateString(t('fr-FR'))}</Td>
                                  <Td>
                                    <Flex>
                                      <Stack direction='row' mr="3px">
                                        <Switch
                                          colorScheme='green'
                                          isChecked={row.etat}
                                          onChange={() => handleEtatClick(row.id, row.etat)}
                                        />
                                      </Stack>
                                      <Badge
                                        rounded={'lg'}
                                        colorScheme={!row.etat ? 'yellow' : 'teal'}
                                      >
                                        {row.etat ? t('Réglé') : t('En cours')}
                                      </Badge>
                                    </Flex>
                                  </Td>
                                  <Td>{row.category === "technical_support" ? t("Support technique") :
                                    row.category === "account_assistance" ? t("Assistance pour le compte") :
                                      row.category === "feedback_suggestions" ? t("Commentaires et suggestions") :
                                        row.category === "content_issues" ? t("Problèmes de contenu") :
                                          row.category === "general_inquiries" ? t("Demandes générales") :
                                            row.category === "problem_with_partner" ? t("Problème avec partenaire") : ""}</Td>


                                  {/* <Td p={4}>

                                <Button
                                  size="sm"
                                  onClick={() => {
                                    setDeleteId(row.id);
                                    setSujet(row.sujet);
                                    setContent(row.content);
                                    onOpen();
                                  }}
                                  colorScheme='blue'
                                  leftIcon={<BiDetail />}>
                                  {t("Afficher")}
                                </Button></Td> */}

                                  {/* <Td p={4}>
                                    <Button
                                      size="sm"
                                      //onClick={onOpen}

                                      colorScheme='green'
                                      onClick={() => {
                                        setDeleteId(row.id);
                                        setReponse(row.response);
                                        setReponseUser(row.responseUser)
                                        onOpenAlert();
                                        setResUserByWho(row.responseUserbywho)
                                        setUserTime(row.responseUsertime)

                                        setResByWho(row.responsebywho)
                                        setTime(row.responsetime)
                                      }}
                                      leftIcon={<MdOutlineQuestionAnswer />}>
                                      {t("Repondre")}
                                    </Button></Td>

                                  <Td p={4}><Popover placement="left" >
                                    <PopoverTrigger>
                                      <Button
                                        size="sm"
                                        mr="5px"
                                        bg="gray.300"
                                        color={"black"}
                                        leftIcon={<MdHistory />}>
                                        {t("Historique")}
                                      </Button>

                                    </PopoverTrigger>
                                    <PopoverContent w={"full"} color="black" bgGradient='linear(to-r, white, gray)' >
                                      <PopoverHeader letterSpacing={1.5} pt={4} fontWeight="bold" border="0">
                                        {t("Historique")}
                                      </PopoverHeader>
                                      <PopoverArrow bg="gray" />
                                      <PopoverCloseButton />
                                      <PopoverBody>

                                        <div style={{ marginBottom: '8px' }}>
                                          {t("Modifié par")} : {row.edited_by}
                                        </div>

                                        <div>
                                          {t("Date de dernière modification")}: {new Date(row.date_modification).toLocaleString(t('fr-FR'))}
                                        </div>
                                      </PopoverBody>
                                      <PopoverHeader pt={4} fontWeight="bold" border="0">
                                      </PopoverHeader>
                                    </PopoverContent>
                                  </Popover></Td> */}
                                  <Td p={4}>

                                    <Button
                                      onClick={() => {
                                        setDeleteId(row.id);
                                        setSujet(row.sujet);
                                        setContent(row.content);
                                        onOpen();
                                      }}
                                      colorScheme='purple'
                                      variant={"outline"}
                                      leftIcon={<BiDetail />}>
                                      {t("Afficher")}
                                    </Button></Td>


                                  <Td>
                                    <Menu >
                                      <MenuButton
                                        as={IconButton}
                                        aria-label='Options'
                                        icon={<HamburgerIcon />}
                                        variant='outline'
                                      />
                                      <MenuList>
                                        <MenuItem onClick={() => {
                                          setDeleteId(row.id);
                                          setReponse(row.response);
                                          setReponseUser(row.responseUser)
                                          onOpenAlert();
                                          setResUserByWho(row.responseUserbywho)
                                          setUserTime(row.responseUsertime)

                                          setResByWho(row.responsebywho)
                                          setTime(row.responsetime)
                                        }} icon={<MdOutlineQuestionAnswer />} >
                                          Repondre
                                        </MenuItem>
                                        <MenuItem icon={<MdHistory />} >
                                          Historique
                                        </MenuItem>

                                      </MenuList>
                                    </Menu>
                                  </Td>
                                  {/* <Td>
                                    <Button
                                      size="sm"
                                      //onClick={onOpen}
                                      //onClick={() => handleDelete(row.id)}
                                      onClick={() => {
                                        setDeleteId(row.id);
                                        onOpenAlert();
                                      }}
                                      colorScheme='red'
                                      leftIcon={<AiFillDelete />}>
                                      Supprimer
                                    </Button></Td> */}
                                </Tr>
                              ))}
                          </>}

                        {((searchTerm || selectedEtat !== null || selectedCategory !== "") && paginationDataCallCenter?.length === 0 || (checkLengthDataC)) && (
                          <Tr>
                            <Td colSpan={10}>{t("Aucune ligne correspondante n'a été trouvée.")}</Td>
                          </Tr>
                        )}
                      </Tbody>
                    </Table>

                  </TableContainer>
                  {/* //////////////////////////////////////////Pagination////////////////////////////////////////// */}
                  <Flex flexDirection={{ base: 'column', lg: "row" }} justify="space-between" align="center" w="100%">
                    <Box flex="1">
                      <MyPagination
                        paginationData={paginationDataCallCenter}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        PAGE_SIZE={pageSize}
                      />
                    </Box>

                    <Select rounded={"md"} size={"sm"} w="70px" value={pageSize} onChange={handlePageSizeChange}>
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </Select>
                  </Flex>
                  {/* //////////////////////////////////////////Pagination////////////////////////////////////////// */}

                </Stack>
              </Flex>
            </TabPanel>

            <TabPanel>
              <Flex
                align={'center'}
                justify={'center'}

              >
                <Stack

                  w={'full'}
                  maxW='full'
                  bg={bg}
                  rounded={'xl'}
                  p={6}
                  my={5}>
                  {/* Search input */}
                  <Flex
                    justifyContent="space-between"
                    alignItems="center"
                    direction={{ base: 'column', lg: 'row' }}
                    mb={{ base: 2, md: 4 }}
                  >
                    <Flex direction={{ base: 'column', lg: 'row' }} mb={3} w={{ base: '100%', lg: "70%" }} >
                      <Flex w={{ base: '100%', lg: "65%" }} mb={{ base: 3, lg: 0 }}>
                        <Select borderRadius="5" fontSize={{ base: 13, lg: 16 }} w={{ base: '70%', lg: '70%' }} mr={3} value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
                          <option value="">{t("Toutes les catégories")}</option>
                          <option value="technical_support">{t("Support technique")}</option>
                          <option value="account_assistance">{t("Assistance pour le compte")}</option>
                          <option value="feedback_suggestions">{t("Commentaires et suggestions")}</option>
                          <option value="content_issues">{t("Problèmes de contenu")}</option>
                          <option value="general_inquiries">{t("Demandes générales")}</option>
                          {/* <option value="problem_with_client">Problème avec client</option> */}
                        </Select>

                        <Select mr={{ base: 0, lg: 3 }} borderRadius="5" fontSize={{ base: 13, lg: 16 }} w={{ base: '30%', lg: '30%' }} value={selectedEtat} onChange={(e) => setSelectedEtat(e.target.value === '' ? null : e.target.value === 'true')}>
                          <option value="">{t("Tout")}</option>
                          <option value="true">{t("Réglé")}</option>
                          <option value="false">{t("En cours")}</option>
                        </Select>
                      </Flex>
                      <Input borderRadius={"5"} onChange={e => setDate(e.target.value)} w={{ base: '100%', lg: '20%' }} placeholder='Select Date' size='md' type='month' />

                    </Flex>

                    <InputGroup w={{ base: '100%', lg: "30%" }}>
                      <InputLeftElement
                        pointerEvents='none'
                        children={<SearchIcon color='gray.300' />}
                      />
                      <Input
                        borderRadius="5"
                        placeholder={t("Recherche...")}
                        value={searchTerm}
                        onChange={(e) => {
                          setCurrentPage(0)
                          setSearchTerm(e.target.value)
                        }}
                        mb={4}
                        sx={{
                          marginLeft: 'auto',
                        }}
                      />
                    </InputGroup>

                  </Flex>

                  {/* Plainte Table  */}

                  <TableContainer>
                    <Table variant='simple' >
                      <Thead>
                        <Tr>
                          <Th borderBottomColor='gray.400'>Code</Th>
                          <Th borderBottomColor='gray.400' >{t("Stock Manager")}</Th>
                          <Th borderBottomColor='gray.400'>Date</Th>
                          <Th borderBottomColor='gray.400'>{t("État")}</Th>
                          <Th borderBottomColor='gray.400'>{t("Catégorie")}</Th>
                          <Th borderBottomColor='gray.400'>{t("Contenu")}</Th>
                          {/* <Th borderBottomColor='gray.400'>{t("Réponse")}</Th>
                          <Th borderBottomColor='gray.400'>{t("Historique")}</Th> */}
                          <Th borderBottomColor='gray.400'>Options</Th>

                        </Tr>
                      </Thead>
                      <Tbody>
                        {loadingData &&
                          <Tr>
                            <Td><Skeleton size='10' /></Td>
                            <Td> <Skeleton height='20px' /></Td>
                            <Td> <Skeleton height='20px' /></Td>
                            <Td> <Skeleton height='20px' /></Td>
                            <Td> <Skeleton height='20px' /></Td>
                            <Td> <Skeleton height='20px' /></Td>
                            <Td> <Skeleton height='20px' /></Td>

                          </Tr>}
                        {(!searchTerm && selectedEtat === null && !selectedCategory) && paginationDataStockManager?.length === 0 ? (
                          <Tr>
                            <Td colSpan={11}>{t("Il n'y a pas de tickets à afficher")}</Td>
                          </Tr>) :
                          <>
                            {(paginationDataStockManager?.length !== 0) &&
                              dataStockManagers?.map((row) => (
                                <Tr key={row.id}>
                                  <Td>{row.code}</Td>
                                  <Td>{row.first_name} {row.last_name}</Td>

                                  <Td>{new Date(row.created_at).toLocaleDateString(t('fr-FR'))}</Td>
                                  <Td>
                                    <Flex>
                                      <Stack direction='row' mr="3px">
                                        <Switch
                                          colorScheme='green'
                                          isChecked={row.etat}
                                          onChange={() => handleEtatClick(row.id, row.etat)}
                                        />
                                      </Stack>
                                      <Badge
                                        rounded={'lg'}
                                        colorScheme={!row.etat ? 'yellow' : 'teal'}
                                      >
                                        {row.etat ? t('Réglé') : t('En cours')}
                                      </Badge>
                                    </Flex>
                                  </Td>
                                  <Td>{row.category === "technical_support" ? t("Support technique") :
                                    row.category === "account_assistance" ? t("Assistance pour le compte") :
                                      row.category === "feedback_suggestions" ? t("Commentaires et suggestions") :
                                        row.category === "content_issues" ? t("Problèmes de contenu") :
                                          row.category === "general_inquiries" ? t("Demandes générales") :
                                            row.category === "problem_with_partner" ? t("Problème avec partenaire") : ""}</Td>


                                  {/* <Td p={4}>

                                <Button
                                  size="sm"
                                  onClick={() => {
                                    setDeleteId(row.id);
                                    setSujet(row.sujet);
                                    setContent(row.content);
                                    onOpen();
                                  }}
                                  colorScheme='blue'
                                  leftIcon={<BiDetail />}>
                                  {t("Afficher")}
                                </Button></Td> */}

                                  {/* <Td p={4}>
                                    <Button
                                      size="sm"
                                      //onClick={onOpen}

                                      colorScheme='green'
                                      onClick={() => {
                                        setDeleteId(row.id);
                                        setReponse(row.response);
                                        setReponseUser(row.responseUser)
                                        onOpenAlert();
                                        setResUserByWho(row.responseUserbywho)
                                        setUserTime(row.responseUsertime)

                                        setResByWho(row.responsebywho)
                                        setTime(row.responsetime)
                                      }}
                                      leftIcon={<MdOutlineQuestionAnswer />}>
                                      {t("Repondre")}
                                    </Button></Td>

                                  <Td p={4}><Popover placement="left" >
                                    <PopoverTrigger>
                                      <Button
                                        size="sm"
                                        mr="5px"
                                        bg="gray.300"
                                        color={"black"}
                                        leftIcon={<MdHistory />}>
                                        {t("Historique")}
                                      </Button>

                                    </PopoverTrigger>
                                    <PopoverContent w={"full"} color="black" bgGradient='linear(to-r, white, gray)' >
                                      <PopoverHeader letterSpacing={1.5} pt={4} fontWeight="bold" border="0">
                                        {t("Historique")}
                                      </PopoverHeader>
                                      <PopoverArrow bg="gray" />
                                      <PopoverCloseButton />
                                      <PopoverBody>

                                        <div style={{ marginBottom: '8px' }}>
                                          {t("Modifié par")} : {row.edited_by}
                                        </div>

                                        <div>
                                          {t("Date de dernière modification")}: {new Date(row.date_modification).toLocaleString(t('fr-FR'))}
                                        </div>
                                      </PopoverBody>
                                      <PopoverHeader pt={4} fontWeight="bold" border="0">
                                      </PopoverHeader>
                                    </PopoverContent>
                                  </Popover></Td> */}
                                  <Td p={4}>

                                    <Button
                                      onClick={() => {
                                        setDeleteId(row.id);
                                        setSujet(row.sujet);
                                        setContent(row.content);
                                        onOpen();
                                      }}
                                      colorScheme='purple'
                                      variant={"outline"}
                                      leftIcon={<BiDetail />}>
                                      {t("Afficher")}
                                    </Button></Td>


                                  <Td>
                                    <Menu >
                                      <MenuButton
                                        as={IconButton}
                                        aria-label='Options'
                                        icon={<HamburgerIcon />}
                                        variant='outline'
                                      />
                                      <MenuList>
                                        <MenuItem onClick={() => {
                                          setDeleteId(row.id);
                                          setReponse(row.response);
                                          setReponseUser(row.responseUser)
                                          onOpenAlert();
                                          setResUserByWho(row.responseUserbywho)
                                          setUserTime(row.responseUsertime)

                                          setResByWho(row.responsebywho)
                                          setTime(row.responsetime)
                                        }} icon={<MdOutlineQuestionAnswer />} >
                                          Repondre
                                        </MenuItem>
                                        <MenuItem icon={<MdHistory />} >
                                          Historique
                                        </MenuItem>

                                      </MenuList>
                                    </Menu>
                                  </Td>
                                  {/* <Td>
                                    <Button
                                      size="sm"
                                      //onClick={onOpen}
                                      //onClick={() => handleDelete(row.id)}
                                      onClick={() => {
                                        setDeleteId(row.id);
                                        onOpenAlert();
                                      }}
                                      colorScheme='red'
                                      leftIcon={<AiFillDelete />}>
                                      Supprimer
                                    </Button></Td> */}
                                </Tr>
                              ))}
                          </>}


                        {((searchTerm || selectedEtat !== null || selectedCategory !== "") && paginationDataStockManager?.length === 0 || (checkLengthDataS)) && (
                          <Tr>
                            <Td colSpan={10}>{t("Aucune ligne correspondante n'a été trouvée.")}</Td>
                          </Tr>
                        )}
                      </Tbody>
                    </Table>

                  </TableContainer>

                  {/* //////////////////////////////////////////Pagination////////////////////////////////////////// */}
                  <Flex flexDirection={{ base: 'column', lg: "row" }} justify="space-between" align="center" w="100%">
                    <Box flex="1">
                      <MyPagination
                        paginationData={paginationDataStockManager}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        PAGE_SIZE={pageSize}
                      />
                    </Box>

                    <Select rounded={"md"} size={"sm"} w="70px" value={pageSize} onChange={handlePageSizeChange}>
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </Select>
                  </Flex>
                  {/* //////////////////////////////////////////Pagination////////////////////////////////////////// */}

                </Stack>
              </Flex>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Stack>

      <Modal
        closeOnOverlayClick={plainteData.response ? false : true}
        isOpen={isAlertOpen}
        onClose={() => {
          setMessage('')
          setPlainteData({})
          onCloseAlert()
        }}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t("Réponse")}</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            {/* <FormControl>
              <Textarea
                maxLength={250}
                borderColor="gray.300"
                defaultValue={reponse}
                _hover={{
                  borderRadius: 'gray.300',
                }}
                h="100px"
                name="response"
                onChange={handleInputChange}
                placeholder="Ecrivez votre réponse"
              />
            </FormControl> */}
            {message &&
              <Alert fontSize={"sm"} padding={2} mb={2} status='error' rounded="md">
                <AlertIcon />
                {message}
              </Alert>
            }

            <FormControl>
              {

                <>
                  {formatDateToCustomFormat(time) > formatDateToCustomFormat(userTime) ?
                    <>
                      {/* {reponseUser ?
                        <Flex direction={"column"} >

                          <Text ml={2} fontSize={"xs"}>{resUserByWho} </Text>
                          <Flex bg="gray.100" color="black" rounded="2xl" padding={2} w="50%" justifyContent="start">{reponseUser}</Flex>
                          <Text w={"50%"} align={"end"} fontSize={10}>{formatDateToCustomFormat(userTime)}</Text>
                        </Flex>

                        : null} */}
                      {reponse ? <Flex w="100%" justifyContent="end" alignItems="right">

                        <Flex direction={"column"} justifyContent="end" w={"100%"} >
                          <Text ml={2} fontSize={"xs"}>{resByWho} </Text>
                          <Flex bg="green.100" color="black" rounded="2xl" padding={2} justifyContent="end">
                            <Text w="100%">{reponse}</Text>
                          </Flex>
                          <Text align={"end"} fontSize={10}>{formatDateToCustomFormat(time)}</Text>

                        </Flex>
                      </Flex> : null}
                    </> : <>

                      {reponse ? <Flex w="100%" justifyContent="end" alignItems="right">

                        <Flex direction={"column"} justifyContent="end" w={"50%"} >
                          <Text ml={2} fontSize={"xs"}>{resByWho} </Text>
                          <Flex bg="green.100" color="black" rounded="2xl" padding={2} justifyContent="end">
                            <Text w="100%">{reponse}</Text>
                          </Flex>
                          <Text align={"end"} fontSize={10}>{formatDateToCustomFormat(time)}</Text>

                        </Flex>
                      </Flex> : null}
                      {reponseUser ?
                        <Flex direction={"column"} >

                          <Text ml={2} fontSize={"xs"}>{resUserByWho} </Text>
                          <Flex bg="gray.100" color="black" rounded="2xl" padding={2} w="50%" justifyContent="start">{reponseUser}</Flex>
                          <Text w={"50%"} align={"end"} fontSize={10}>{formatDateToCustomFormat(userTime)}</Text>
                        </Flex>

                        : null}
                    </>}


                </>
              }
              <Input mt={5} maxLength={250}
                borderColor="gray.300"
                _hover={{
                  borderRadius: 'gray.300',
                }}
                onChange={handleInputChange}
                name="reponse"
                placeholder={t("Ecrivez votre réponse")}></Input>

            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button onClick={sendResponse} colorScheme='blue' isDisabled={!plainteData.response}>
              {t("Envoyer")}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* <AlertDialog
        isOpen={isAlertOpen}
        leastDestructiveRef={cancelRef}
        onClose={onCloseAlert}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Supprimer le message
            </AlertDialogHeader>

            <AlertDialogBody>
              êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onCloseAlert}>
                Annuler
              </Button>
              <Button onClick={() => "handleDelete(deleteId)"} colorScheme='red' ml={3}>
                Supprimer
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog> */}
      <Modal onClose={onClose} isOpen={isOpen} isCentered>
        <ModalOverlay />
        <ModalContent >
          <ModalHeader>{sujet}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {content}
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose}>{t("Fermer")}</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>


    </Box>
  )
}


